<template lang="pug">
app-card
  div( @click="$emit('clickCard')" )
    app-card-header 
      app-card-title {{ court.title }}
    app-card-body
      app-card-caption
        card-row-label-value( label="Алиас суда" :value="court.alias" )
  app-card-footer
    div.d-flex.justify-space-between.align-center.pt-2.pb-2
      span {{ link }}
      v-btn( small @click="copyToClipboard" )
        v-icon( size="24" dark center small ) content_copy
    div( v-if="isCopied" style="color: #00bcd4" ) Ссылка скопирована!
</template>

<script>
import { mapGetters } from 'vuex'
import CardRowLabelValue from '../components/CardRowLabelValue.vue'

export default {
  name: "ExpertCourtCard",

  components: {
    CardRowLabelValue
  },

  props: {
    court: null,
    regionId: null
  },

  data() {
    return {
      isCopied: false
    }
  },

  computed: {
    ...mapGetters('expert', ['getRegionById']),
    link() {
      return window.location.origin + `/payment_order?region=${this.getRegionById(this.regionId)?.alias}&sud=${this.court.alias}`
    }
  },

  methods: {
    copyToClipboard() {
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(this.link).then(() => {
          this.isCopied = true
          setTimeout(() => {
            this.isCopied = false
          }, 2000)
        })
      } else {
        const textArea = document.createElement("textarea");
        textArea.value = this.link;
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          this.isCopied = true
          setTimeout(() => {
            this.isCopied = false
          }, 2000)
        } catch (err) {
          console.error('Unable to copy to clipboard', err);
        }
        document.body.removeChild(textArea);
      }
    }
  }
}
</script>